import { render } from "./priceOffer.vue?vue&type=template&id=724832c7&scoped=true"
import script from "./priceOffer.vue?vue&type=script&lang=js"
export * from "./priceOffer.vue?vue&type=script&lang=js"

import "./priceOffer.vue?vue&type=style&index=0&id=724832c7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724832c7"]])

export default __exports__